module.exports = __webpack_public_path__ + "static/media/money-real.24b3b316.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/money-real.svg
// module id = ./src/assets/icons/money-real.svg
// module chunks = 0